import { render } from "./processes.vue?vue&type=template&id=14f8e76b&ts=true"
import script from "./processes.vue?vue&type=script&lang=ts"
export * from "./processes.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__